import { type FairsTranslations } from './fairs.translations.pl.ts';

export const fairsTranslations: FairsTranslations = {
  addCandidates: 'Ajouter des candidats',
  bulk: {
    addMore: "Ajouter d'autres candidats",
    cancel: 'Annuler',
    close: 'Fermer',
    description:
      'Collez les adresses e-mail recueillies sur le stand : une par ligne ou séparées par des virgules ou des points-virgules. Vous pouvez coller toute une colonne Excel.',
    emailsLabel: 'Adresses e-mail',
    emailsPlaceholder: 'anna.nowak@student.pl\njan.kowalski@universite.edu.pl',
    error: "Les candidats n'ont pas pu être ajoutés. Veuillez réessayer.",
    fairHint: 'Les candidats portant le même nom de salon forment une seule carte de résultats.',
    fairLabel: 'Nom du salon',
    fairPlaceholder: "ex. Salon de l'emploi AGH, mars 2027",
    found: 'Adresses reconnues : {{count}}',
    result: {
      added: 'Ajoutés : {{count}}',
      alreadyAdded: 'Déjà sur la liste : {{count}}',
      invalid: 'Adresses e-mail non valides : {{count}}',
      title: 'Terminé',
    },
    submit: 'Ajouter à la liste',
    title: 'Ajouter des candidats rencontrés sur un salon',
    tooMany: "Vous pouvez ajouter jusqu'à {{max}} adresses à la fois.",
  },
  edit: {
    cancel: 'Annuler',
    emailLabel: 'Adresse e-mail',
    error: "Les modifications n'ont pas pu être enregistrées.",
    fairLabel: 'Nom du salon',
    save: 'Enregistrer',
    success: 'Modifications enregistrées.',
    title: 'Modifier un candidat du salon',
  },
  list: {
    addedBy: 'ajouté par {{name}}',
    allTitle: 'Tous les candidats des salons',
    columns: {
      added: 'Ajouté à la liste',
      candidate: 'Candidat',
      fair: 'Salon',
      registered: 'Inscription',
      score: 'Score',
      status: 'Étape du recrutement',
    },
    edit: 'Modifier',
    empty: "Il n'y a encore aucun candidat sur cette liste.",
    fairTitle: 'Candidats : {{fair}}',
    notRegistered: 'Pas encore inscrit',
    openProfile: 'Ouvrir le profil du candidat',
    profileError: "Le profil du candidat n'a pas pu être ouvert.",
  },
  results: {
    allFairs: 'Tous les salons',
    empty:
      "Aucun candidat de salon pour l'instant. Ajoutez les adresses e-mail recueillies sur le stand pour voir combien ont rejoint le recrutement et combien ont été recommandés.",
    funnel: {
      added: 'Ajoutés depuis le salon',
      quizFinished: 'Quiz terminé',
      recommended: 'Recommandés',
      registered: 'Inscrits',
    },
    lastAdded: 'Dernier ajout le {{date}}',
    noName: 'Salon sans nom',
    recommendedShare: 'des candidats du salon recommandés',
    showCandidates: 'Voir les candidats',
    title: 'Résultats des salons',
  },
  subtitle:
    "Les candidats rencontrés sur les salons de l'emploi et leur progression dans le recrutement",
  title: "Salons de l'emploi",
};
